(function () {
  'use strict';

  var id = 'network',
    networkMeasures = null;
  angular.module('wsLrs.cards').factory(id + '.Utils', ['CardQueryResource', 'AggregationUtils', 'wsColors', function (CardQueryResource, AggUtils, wsColors) {
    return {
      fetchData: function fetchData(cfg) {
        cfg = cfg || {};
        return CardQueryResource.getWithProgress("/network/data", cfg.cardId, cfg.params, cfg.cardToPreview, 'network-graph-' + cfg.cardId);
      },
      getNetworkGraph: function getNetworkGraph(data, config) {
        var root = {
          id: "root",
          name: AggUtils.getDimensionInSentence(config.dimensions[0], true),
          size: 1000,
          color: wsColors.wsBlue
        };
        var graph = {
          nodes: [root],
          links: []
        };
        _.each(data.data, function (d) {
          var dimensionNode = {
            name: AggUtils.getDimensionDisplay(d.values[0], config.dimensions[0]),
            id: "dimension:" + d.values[0].value,
            size: 4000,
            color: wsColors.wsBlue
          };
          var dimIdx = graph.nodes.push(dimensionNode) - 1;
          graph.links.push({
            source: 0,
            target: dimIdx
          });
          _.each(d.aggregations, function (a, idx) {
            //todo: what if this measure is a list of things????
            var measure = config.measures[idx];
            if (['LIST', 'SET'].indexOf(measure.aggregation.type) > -1) {
              _.each(a.details, function (d) {
                var measureNode = {
                  name: d.label,
                  id: "measure:" + idx + ":" + d.value,
                  size: _.isNumber(a.value) ? a.value * 1000 : 4000,
                  color: wsColors.wsGreen
                };
                var measureIdx = _.findIndex(graph.nodes, function (n) {
                  return n.id === measureNode.id;
                });
                if (measureIdx === -1) {
                  measureIdx = graph.nodes.push(measureNode) - 1;
                }
                graph.links.push({
                  source: dimIdx,
                  target: measureIdx
                });
              });
            } else {
              var measureNode = {
                name: measure.name + " : " + AggUtils.getMeasureValueDisplay(a, measure),
                id: "measure:" + idx + ":" + a.value,
                size: _.isNumber(a.value) ? a.value * 1000 : 4000,
                color: wsColors.wsGreen
              };
              var measureIdx = _.findIndex(graph.nodes, function (n) {
                return n.id === measureNode.id;
              });
              if (measureIdx === -1) {
                measureIdx = graph.nodes.push(measureNode) - 1;
              }
              graph.links.push({
                source: dimIdx,
                target: measureIdx
              });
            }
          });
        });
        return graph;
      }
    };
  }]).config(['$routeProvider', function ($routeProvider) {
    // Add routes
    $routeProvider.
    //route format MUST be: card.template.name + "/" + card.id
    when('/network/:cardId', {
      templateUrl: 'modules/app/network/network-detail.html',
      controller: id + ".Detail",
      resolve: {
        cardLoader: ['CardLoader', function (CardLoader) {
          return CardLoader.loadCards();
        }]
      }
    }).when('/network/:cardId/top', {
      templateUrl: 'modules/app/network/network-card.html',
      resolve: {
        cardLoader: ['CardLoader', function (CardLoader) {
          return CardLoader.loadCards();
        }]
      }
    });
  }]).run(['CardIconMap', function (CardIconMap) {
    CardIconMap.register({
      "network": "activity"
    });
  }]).controller(id + ".CardConfiguration", ['$controller', '$rootScope', '$scope', 'Measures', function ($controller, $rootScope, $scope, Measures) {
    $scope.tempMeasures = networkMeasures;
    $scope.templateType = id;
    $scope.getMeasures = Measures.getCommonMeasures;
    $scope.newtworkHelpText = {
      helpTitle: 'Network Graph',
      detailText: "In the Network section, you'll choose how you want to group data (in the Organized " + "menu) and what measures you'll want to see (using the Measures menu). Choose an option in the " + "Organized menu first, and then select as many measures as you'd like by choosing them in the " + "dropdown and clicking Add Measure. Remove a measure by clicking the X next to a selected measure. "
    };
    $controller("AggregationCardConfiguration", {
      $scope: $scope
    });

    //clear out any listerMeasures on a new explore card event
    $rootScope.$on('explore-card', function () {
      networkMeasures = null;
    });
  }]).controller(id + ".Card", ["$scope", "CardRegistry", id + '.Utils', 'AggregationUtils', 'wsEventNames', '$routeParams', function ($scope, CardRegistry, Utils, AggUtils, wsEvents, $routeParams) {
    if (!$scope.cardId && $routeParams.cardId) {
      $scope.cardId = $routeParams.cardId;
    }
    $scope.config = CardRegistry.get($scope.cardId).configuration;
    $scope.measures = $scope.config.measures;
    if (!$scope.config.measures || $scope.config.measures.length < 1) {
      $scope.hasData = false;
      $scope.noDataMsg = "Please select at least 1 measure";
      return;
    }
    $scope.defaultSummary = 'Network Graph of measures organized by ' + AggUtils.getDimensionInSentence($scope.config.dimensions[0], true) + '.';
    var fetchCfg = {
      cardId: $scope.cardId,
      cardToPreview: $scope.cardToPreview,
      params: {
        "_limit": 10,
        "_offset": 0
      }
    };
    Utils.fetchData(fetchCfg).then(function (r) {
      // Advertise that the preview loaded, with the preview data
      if ($scope.cardToPreview) {
        $scope.$emit(wsEvents.card.preview.loaded, r);
      }

      //do we use this?
      $scope.averages = r.results[0].result.stats;
      $scope.networkGraph = Utils.getNetworkGraph(r.results[0].result, $scope.config);
      $scope.hasData = r.results[0].result.data.length > 0 && $scope.measures.length > 0;
    }, function () {
      $scope.hasData = false;
    });
  }]).controller(id + ".Detail", ["$scope", "$routeParams", "CardRegistry", "CardUtils", id + '.Utils', function ($scope, $routeParams, CardRegistry, CardUtils, Utils) {
    $scope.cardId = $routeParams.cardId;
    $scope.card = CardRegistry.get($scope.cardId);
    $scope.config = $scope.card.configuration;
    if (!$scope.config.measures || $scope.config.measures.length < 1) {
      $scope.hasData = false;
      $scope.noDataMsg = "Please select at least 1 measure";
      return;
    }
    var fetchCfg = {
      cardId: $scope.cardId,
      cardToPreview: $scope.cardId === 'preview' ? $scope.card : null,
      params: {}
    };
    $scope.nodeName = null;
    $scope.toggleLabels = function () {
      $scope.networkGraph.toggleLabels();
    };
    $scope.expandAll = function () {
      $scope.networkGraph.expandAll();
    };
    $scope.findNode = function () {
      $scope.networkGraph.findNode($scope.nodeName);
      $scope.nodeName = "";
    };
    $scope.pagenote = {
      "clearCacheAction": "cards/" + $scope.cardId + "/cache"
    };
    Utils.fetchData(fetchCfg).then(function (r) {
      $scope.data = r.results[0].result;
      $scope.hasData = true;
      $scope.pagenote.setReportMetadata(r);
      $scope.stats = $scope.data.stats; //do we use this?

      $scope.networkGraph = Utils.getNetworkGraph($scope.data, $scope.config);
    }, function () {
      $scope.hasData = false;
    });
  }]);
})();
